import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Two opposed arrows — one up, one down — used as the sort-direction control
 * on the ticket Timeline drawer.
 *
 * Distinct from `VerticalArrowsIcon`, which stacks a chevron pair on a single
 * axis (an expand/collapse affordance). This one reads as "reorder".
 *
 * Stroked in `currentColor`, so the consumer sets the colour via `sx`.
 */
export const ArrowDualIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M10 8 7 5 4 8M7 19V5M14 16l3 3 3-3M17 5v14"
      />
    </svg>
  </SvgIcon>
);
